import { cn } from "@/utils/cn";

type LoadingStateProps = {
  message?: string;
  className?: string;
  fullPage?: boolean;
};

export function LoadingState({
  message = "Loading...",
  className,
  fullPage,
}: LoadingStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-4",
        fullPage && "min-h-[50vh]",
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <div className="flex gap-1">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="h-2 w-2 rounded-full bg-primary animate-pulse-soft"
            style={{ animationDelay: `${i * 150}ms` }}
          />
        ))}
      </div>
      <p className="text-sm text-muted-foreground">{message}</p>
    </div>
  );
}
